import AdminCard from "./AdminCard";


export default function AdminTable({
  headers,
  children,
  loading = false,
  empty = false,
  emptyMessage = "No data found",
}) {

  return (
    <AdminCard className="overflow-hidden">

      {loading ? (

        <div className="py-10 text-center">

          <div
            className="
              animate-spin
              rounded-full
              h-12
              w-12
              border-t-2
              border-b-2
              border-green-400
              mx-auto
            "
          />

          <p className="text-gray-400 mt-4">
            Loading...
          </p>

        </div>

      ) : empty ? (

        <div className="py-10 text-center text-gray-400">
          {emptyMessage}
        </div>

      ) : (

        <div className="overflow-x-auto">

          <table className="min-w-full">

            <thead className="bg-black/30">

              <tr>

                {headers.map((header) => (
                  <th
                    key={header}
                    className="p-4 text-left text-green-300"
                  >
                    {header}
                  </th>
                ))}

              </tr>

            </thead>


            <tbody>
              {children}
            </tbody>


          </table>

        </div>

      )}

    </AdminCard>
  );
}